import { useEffect, useState } from "react";
import TabMenuItem from "./TabMenuItem";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { setTabMenuType } from "../../../Redux/reducers/participantTabSlice";
import { featuresMap } from "../../../utils/features";
import { permissions } from "../../../utils/roles";
type ItemsType = {
  key: string;
  label: string;
  display: boolean;
};

const ParticipantProfile = () => {
  const dispatch = useAppDispatch();
  const type = useAppSelector((state) => state.participantTab.menuType);
  const [menuList, setMenuList] = useState<ItemsType[]>([]);
  const features = useAppSelector((state) => state.study.features);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const [canView] = useState(
    studyPermissions.includes(permissions.viewAppointment)
  );

  useEffect(() => {
    const items: ItemsType[] = [
      {
        key: "participant_information",
        label: "Participant Information",
        display: true,
      },
      // {
      //   key: "medication",
      //   label: "Medication",
      //   display: features?.[featuresMap?.medication],
      // },
      {
        key: "consent",
        label: "Consent Forms",
        display: features?.[featuresMap?.eConsent],
      },
      {
        key: "sunshine_forms",
        label: "Sunshine Forms",
        display: features?.[featuresMap?.eConsent],
      },
      // {
      //   key: "appointments",
      //   label: "Appointments",
      //   display: features?.[featuresMap?.appointment] && canView,
      // },
      // {
      //   key: "telehealth",
      //   label: "Telehealth Calls",
      //   display: features?.[featuresMap?.appointment] && canView,
      // },
    ].filter((item) => item.display);
    setMenuList(items);

    const selectedMenuItem =
      sessionStorage.getItem("menu-type") || items?.[0]?.key;

    dispatch(setTabMenuType(selectedMenuItem));
    sessionStorage.setItem("menu-type", selectedMenuItem);
  }, [canView, dispatch, features]);

  const changeMenuType = (val: string) => {
    dispatch(setTabMenuType(val));
    sessionStorage.setItem("menu-type", val);
  };

  return (
    <>
      {menuList.length > 0 &&
        menuList.map((item: any) => (
          <TabMenuItem
            key={item.key}
            active={type === item.key}
            label={item.label}
            value={item.key}
            handleClick={changeMenuType}
          />
        ))}
    </>
  );
};

export default ParticipantProfile;
